import { CommentsTable } from "@/components/comments/CommentsTable";

export default function Commments() {
    return (
        <div className="flex items-center h-full pt-10 flex-col">
            <CommentsTable />
        </div>
    );
}